import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from 'utils/services';

import { ResponseProps } from 'services/services.types';
import {
  DeleteNotificationsParams,
  GetNotificationsByIdsParams,
  GetNotificationsParams,
  MarkNotificationsSeenParams,
  NotificationsCountResponse,
  NotificationsListResponse
} from './notifications.types';

export const NOTIFICATIONS_DEFAULT_LIMIT = 20;

export const notificationsApi = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    deleteNotifications: build.mutation<void, DeleteNotificationsParams>({
      query: ({ id }) => ({
        method: 'DELETE',
        url: `/patient-notifications/${id}`
      })
    }),
    getNotifications: build.query<NotificationsListResponse, GetNotificationsParams | void>({
      query: (params) => ({
        params: { limit: NOTIFICATIONS_DEFAULT_LIMIT, ...params },
        url: '/patient-notifications'
      })
    }),
    getNotificationsByIds: build.query<NotificationsListResponse, GetNotificationsByIdsParams>({
      query: (params) => ({
        params: { ids: params.ids },
        url: '/patient-notifications'
      })
    }),
    getNotificationsCount: build.query<ResponseProps<NotificationsCountResponse>, void>({
      query: () => '/patient-notifications/count'
    }),
    markNotificationsSeen: build.mutation<void, MarkNotificationsSeenParams>({
      query: (body) => ({
        body,
        method: 'PATCH',
        url: '/patient-notifications/mark-seen'
      })
    })
  }),
  reducerPath: 'notificationsApi'
});

export const {
  useDeleteNotificationsMutation,
  useGetNotificationsByIdsQuery,
  useGetNotificationsCountQuery,
  useGetNotificationsQuery,
  useLazyGetNotificationsByIdsQuery,
  useLazyGetNotificationsCountQuery,
  useLazyGetNotificationsQuery,
  useMarkNotificationsSeenMutation
} = notificationsApi;
